import { PathOptions } from "leaflet";

export const linhas_de_transmissao_base_existente = (feature: any): PathOptions => {
  const vn = feature.properties?.vn;

  // 69 kV - Light purple
  if (vn === 69) {
    return {
      color: "#d78cff",
      weight: 1,
      opacity: 1,
    };
  }

  // 230 kV - Bright green
  if (vn === 230) {
    return {
      color: "#00ff00",
      weight: 1,
      opacity: 1,
    };
  }

  // 500 kV - Red
  if (vn === 500) {
    return {
      color: "#ff0000",
      weight: 1,
      opacity: 1,
    };
  }

  // Default fallback (shouldn't happen if data is complete)
  return {
    color: "#FF4500",
    weight: 1,
    opacity: 1,
  };
};
